import * as React from 'react';
import * as _ from 'lodash'
import moment from 'moment'
import { css } from 'glamor';
import IosCashOutline from 'react-ionicons/lib/IosCashOutline'

import { durationToDDHHMMSSMS, ContactHistoryT } from './ContactTab';
import { styles } from './style';
import IosTextOutline from 'react-ionicons/lib/IosTextOutline'
import { formatDate } from '../../../../utils/utilsT';
import { JobStatusT, JobT } from '../../../../types/Job';
import config from '../../../../constants/config';
import AnnotationSms from './AnnotationSms';
import { Container } from 'react-bootstrap';
import ButtonLoading from '../../../../components/ButtonLoading';

import { AxiosInstance } from '../../../../utils/RequestMethods';
import { Button, Stack } from '@mui/material';
import { SmsAnnotationObject, SmsAnnotationT } from '../../../../types/SmsAnnotationT';
export interface IContactSmsProps {
    job: JobT
    item: ContactHistoryT
    disputeEdit?: boolean
    displayMode?: "edit" | "view"
}

interface MetaSmsT {
    toCountry: string
    toState: string
    toCity: string
    fromZip: string
    fromState: string
    smsStatus: string
    fromCity: string
    numMedia: string
    body: string
    fromCountry: string
    to: string
    toZip: string
    addOns: string
    from: string

}

const initMeta: MetaSmsT = {
    toCountry: "",
    toState: "",
    toCity: "",
    fromZip: "",
    fromState: "",
    smsStatus: "",
    fromCity: "",
    numMedia: "",
    body: "",
    fromCountry: "",
    to: "",
    toZip: "",
    addOns: "",
    from: "",
}
const ContactSms: React.FC<IContactSmsProps> = ({ job, item, disputeEdit, displayMode }) => {
    const [meta, setMeta] = React.useState(initMeta)
    const [isReady, setIsReady] = React.useState(false);

    const [annotations, setAnnotations] = React.useState<Array<SmsAnnotationT>>([])



    React.useEffect(() => {
        if (!_.isEmpty(item.meta)) {
            setMeta({ ...initMeta, ...item.meta })
        }
    }, [item])




    React.useEffect(() => {
        parseDisputeNotes()
    }, [])

    const parseDisputeNotes = (): void => {
        try {

            let smsAnnotations: Array<SmsAnnotationT> = _.isArray(item?.disputeNotes) ? item?.disputeNotes as Array<SmsAnnotationT> : []
            setAnnotations(smsAnnotations)
        }
        catch (err) {
            console.log(err)
        }
    }

    const addNewAnnotation = () => {
        let cloneItems = _.cloneDeep(annotations)
        if (!_.isArray(cloneItems)) {
            cloneItems = []
        }
        let cloneItem = _.cloneDeep(SmsAnnotationObject)
        cloneItems.push(cloneItem)
        setAnnotations(cloneItems)
    }


    const updateLineItemAnnotation = (index: number, item: SmsAnnotationT) => {
        let cloneItems = _.cloneDeep(annotations)
        cloneItems[index] = item
        setAnnotations(cloneItems)
    }

    /**
     * 
     * @param index 
     */
    const removeLineItemAnnotation = (index: number): void => {
        let _cloneItems = _.cloneDeep(annotations)
        const filteredItems = _cloneItems.slice(0, index).concat(_cloneItems.slice(index + 1, _cloneItems.length))
        // console.log("filteredItems", filteredItems)
        setAnnotations(filteredItems)
    }

    const saveAnnotations = async (disputeNotes: Array<SmsAnnotationT>): Promise<string> => {
        let params = {
            "disputeNotes": disputeNotes
        }
        return await AxiosInstance.post(`${config.url.jobs}/${job.id}/communications/${item?.id}/dispute_annotations`, params).then((res) => {
            return 'Notes saved.'
        })
    }

    return (
        <div className={` ${item.direction == "outgoing" ? css(styles.itemContact, styles.right) : styles.itemContact}`} >
            <div className="contact-header">
                <span className="title">
                    <IosTextOutline />
                    &nbsp; &nbsp;
                    <strong className="display-name">{item.sender.firstName} {item.sender.lastName}</strong>
                    &nbsp;&nbsp;
                    <span className="date">{formatDate(moment.utc(item.date), config.dateFormat.dateTime, true)}</span>

                </span>
                {(job.closedIn.communicationId == item.id && (job?.jobStatus == JobStatusT.scheduled || job?.jobStatus == JobStatusT.completed)) && <span className="closed-in"> <IosCashOutline color='green' />  Closed in <strong style={{ color: 'green' }}> {durationToDDHHMMSSMS(job.closedIn.time)}</strong></span>}
            </div>
            <div className="contact-body">
                <div className='d-flex flex-column'>
                    <span className="" >{meta.body}</span>

                    {/* <span className="" >{selectionBody}</span> */}
                </div>
                {(disputeEdit) &&
                    <>

                        {annotations && annotations.map((item: SmsAnnotationT, index: number): JSX.Element => {
                            return <AnnotationSms
                                body={meta?.body}
                                item={item}
                                index={index}
                                key={`Annotation-sms-${index}`}

                                updateLineItem={updateLineItemAnnotation}
                                removeLineItem={removeLineItemAnnotation}
                                displayMode={displayMode}
                            />
                        })}
                        {displayMode == "edit" && <Container className='mt-2 d-flex flex-column' >
                            <Stack spacing={2}>
                                <Button
                                    onClick={() => {
                                        addNewAnnotation()
                                    }}
                                    style={{
                                        width: "20%"
                                    }}
                                    color='info'
                                    variant='contained' >
                                    <i className='fa fa-plus' />&nbsp;  Add Notes
                                </Button>
                                <ButtonLoading
                                    customButton={Button}
                                    // fullWidth
                                    style={{
                                        width: "20%"
                                    }}
                                    customButtonProps={{
                                        color: "success",
                                        variant: "contained"
                                    }}
                                    onClickFetching={async (): Promise<string> => {
                                        return await saveAnnotations(annotations)
                                    }}
                                >
                                    <i className='fa fa-plus' />&nbsp;Save Notes
                                </ButtonLoading>
                            </Stack>
                        </Container>}
                    </>
                }
            </div>
        </div>
    );
}
export default ContactSms;
export { ContactSms };